import {Injectable} from '@angular/core';
import { Platform } from 'ionic-angular';
import 'rxjs/add/operator/map';
import {App} from 'ionic-angular';
import {OauthService} from './oauth.service';
import {Http} from '@angular/http';
import {ToolsService} from './tools.service';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class UpdateAppService extends OauthService {


  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
    private platform: Platform,
  ) {
    super(http, app, appProvider, tools);
  }

  launchStore(versionApp: string) {
    if ((<any>window).cordova) {
      setTimeout(() => {
        if (this.platform.is('android')) {
          if (versionApp === 'v1') {
            window.open(this.appProvider.storeAndroid,"_system");
          } else {
            window.open(this.appProvider.storeAndroidV2,"_system");
          }
          this.platform.exitApp();
        } else if (this.platform.is('ios')) {
          if (versionApp === 'v1') {
            window.open(this.appProvider.storeIos, "_system");
          } else {
            window.open(this.appProvider.storeIosV2, "_system");
          }
          this.platform.exitApp();
        }
      }, 5000);
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/update-app.service.ts